import { Component, OnInit, ElementRef, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { FieldComponent } from './field.component';
import { userSettings } from './../../common/settings'
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-field-write',
  template: ``,
})

export class FieldWriteComponent extends FieldComponent implements OnInit {
  @Input() ShowRealVal: boolean = false;
  @Input() MaxLength: number = 50;
  @Input() MinLength: number = 0;
  @Input() Required: boolean = false;
  @Output() TriggerOutsideErrorAnim = new EventEmitter<boolean>();
  @Output() TriggerTextChanged = new EventEmitter<string>();

  //Form
  Form: FormGroup;
  Validator = [];
  FormError: string = "";
  // Animation
  blinkAnimErr: boolean;
  activeAnimErr: boolean;
  // Disable
  Disable: boolean = false;
  backUpVal: number;

  constructor(private fb: FormBuilder, private translateService: TranslateService) {
    super();
    userSettings.halfSecInter.subscribe(x => {
      if (this.activeAnimErr)
        this.blinkAnimErr = x;
    });

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.checkAndCollectErrors(false);
    });
  }
  ngOnInit() {
    this.resetValidators(this.Required);
  }

  resetValidators(addReq: boolean = false, value: any = undefined) {
    this.Required = addReq;
    this.Validator = [Validators.maxLength(this.MaxLength), Validators.minLength(this.MinLength)];
    if (addReq)
      this.Validator.push(Validators.required);

    this.Form = this.fb.group({
      Field: [value, this.Validator],
    });
  }

  onTextChange() {
    // Reset Animation
    this.activeAnimErr = false;
    this.blinkAnimErr = false;
    this.TriggerOutsideErrorAnim.emit(false);

    let val: string = this.Form.controls.Field.value;
    if (val.length > this.MaxLength)
      this.Form.controls.Field.setValue(val.slice(0, this.MaxLength));

    this.checkAndCollectErrors(false);

    if (this.activeAnimErr)
      this.TriggerTextChanged.emit("");
    else
      this.TriggerTextChanged.emit(this.Form.controls.Field.value);

  }

  getValue(Clear?: boolean): string {
    if (this.Disable)
      return undefined;
    this.checkAndCollectErrors(true);
    // clear field
    if (Clear)
      this.Form.controls.Field.setValue(undefined);
    return this.FormError == "" ? this.Form.controls.Field.value : undefined;
  }

  checkAndCollectErrors(setError: boolean = true) {
    this.FormError = "";
    let val: string = this.Form.controls.Field.value;
    if (!this.checkValValid(val) && this.Required)
      this.FormError += this.translateService.instant('VALIDATIONS.EMPTY') + "\n";
    if (this.checkValValid(val)) {
      if (val.length > this.MaxLength)
        this.FormError += this.translateService.instant('VALIDATIONS.MAXLENGTH') + "\n";
      if (val.length < this.MinLength)
        this.FormError += this.translateService.instant('VALIDATIONS.MINLENGTH') + "\n";
    }
    if (setError && this.FormError != "")
      this.setError();
  }

  checkValValid(val: any): boolean {
    if (val == null)
      return false;
    if (val == undefined)
      return false;
    if (val == '')
      return false;

    return true;
  }

  setError(force: boolean = true) {
    if (force)
      this.Form.controls['Field'].setErrors({ 'incorrect': true });
    this.activeAnimErr = true;
    this.TriggerOutsideErrorAnim.emit(true);
  }

  disable() {
    this.backUpVal = this.Form.controls.Field.value;
    this.Form.controls.Field.setValue('');
    this.Form.disable();
    this.Disable = true;
    // Reset Animation
    this.activeAnimErr = false;
    this.blinkAnimErr = false;
  }

  enable() {
    this.Form.enable();
    this.Form.controls.Field.setValue(this.backUpVal);
    this.Disable = false;
    // Reset Animation
    this.activeAnimErr = false;
    this.blinkAnimErr = false;
  }
}
